var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.Config = (function ($, window, document) {
    var owl_defaults = {
        navText: ["<span class='icon icon-arrow left'> Back", "<span class='icon icon-arrow right'> Next"],
        nav: false,
    };

    return {
        owlDefaults: owl_defaults
    };
})(window.jQuery, window, document);